export { STATUS_CODES } from './status-code';
export { EXPERIMENT } from './experiments';

export const PERSEUS_NAME = 'freelancer_page_perseus';
export const METRICS_PREFIX = `services.${PERSEUS_NAME}`;
export const CONSULTATION_DEFAULT_RESPONSE = {};
